import { reactive, computed } from "@nuxtjs/composition-api";
import { Logger } from "@wemade-vsf/core";
import type { ComputedRef } from "@nuxtjs/composition-api";

import { useWmAttributes } from "@wemade-vsf/catalog/lib/runtime/product/composables/useWmAttributes";

export interface WmSwatchData {
    label: string;
    type: string | null;
    value: string | null;
}

interface UseDeliverySwatchDataInterface {
    load(): Promise<WmSwatchData[]>;
    deliverySwatchData: ComputedRef<WmSwatchData[] | null>;
}

const state = reactive({
    data: null,
});

export default function useDeliverySwatchData(): UseDeliverySwatchDataInterface {
    const deliverySwatchData = computed(() => {
        let data = null;
        if (!state.data) return data;

        return state.data;
    });

    async function load(): Promise<WmSwatchData[]> {
        Logger.debug("useDeliverySwatchData/load");
        const { getSwatchData } = useWmAttributes();

        state.data = await getSwatchData("wm_delivery_time");

        return state.data;
    }

    return {
        load,
        deliverySwatchData,
    };
}
